// extracted by mini-css-extract-plugin
module.exports = {"section":"privacyTableTitle_section__wNCxz","hide":"privacyTableTitle_hide__L9gEV"};